<template>
  <el-cascader ref="ElCascaderDict" :options="options" :props="setting" @change="handdleChange">
    <template v-for="(slot, key) in $scopedSlots" :slot="key" slot-scope="scope">
      <slot :name="key" v-bind="scope"></slot>
    </template>
    <template v-for="(slot, key) in $slots" :slot="key">
      <slot :name="key"></slot>
    </template>
  </el-cascader>
</template>
<script>
import store from "~/store/index.js"
import { ListToTree } from "~/functions/list-tree"
export default {
  name: "el-cascader-dict",
  data() {
    return {
      list: [], //数据列表
      type: "" //请求字典类型
    }
  },
  props: {
    //最大层级
    maxLevel: {
      type: [Number, String]
    },
    dictType: {
      type: [String, Object],
      default: ""
    },
    disableObj: {
      type: Object
    },
    //过滤函数
    filterDataFun: {
      type: Function
    },
    //禁用函数
    disabledDataFun: {
      type: Function
    }
  },
  computed: {
    dictCodes() {
      return store.state.dictCodes
    },
    dictConfig() {
      return store.state.dictConfig
    },
    isGettingAllDictTypes() {
      return store.state.isGettingAllDictTypes
    },
    isGettingDictTypes() {
      return store.state.isGettingDictTypes
    },
    setting() {
      const props = this.$attrs.props??{}
      props.value = props.value??this.dictConfig.treeSetting.idField
      props.label = props.label??this.dictConfig.treeSetting.labelField
      props.children = props.children??this.dictConfig.treeSetting.childrenField
      props.leaf = props.leaf??this.dictConfig.treeSetting.leafField
      return props
    },
    options(){
      const props = this.$attrs.props??{}
      const newProps = {
        idField: props.value??this.dictConfig.treeSetting.idField,
        labelField: props.label??this.dictConfig.treeSetting.labelField,
        childrenField: props.children??this.dictConfig.treeSetting.childrenField,
        leafField: props.leaf??this.dictConfig.treeSetting.leafField
      }
      const treeSetting = Object.assign(this.dictConfig.treeSetting, newProps)
      const treeArr = JSON.parse(JSON.stringify(this.list))
      const data = ListToTree(treeArr, treeSetting)
      // 限制层级
      if (this.maxLevel) {
        this.filterLevel(data, +this.maxLevel)
      }
      return data
    }
  },
  watch: {
    isGettingDictTypes(val) {
      if (!val.includes(this.type)) {
        this.getDictionary_option()
      }
    },
    //请求全部字典后 重新渲染页面
    isGettingAllDictTypes(val) {
      if (!val) {
        this.getDictionary_option()
      }
    }
  },
  mounted() {
    this.getDictionary_option()
  },
  methods: {
    //过滤层级
    filterLevel(arr, maxLevel) {
      for (let i = 0; i < arr.length; i++) {
        const item = arr[i]
        const currentLevel = item[this.dictConfig.treeSetting.levelField]
        if (currentLevel === maxLevel) {
          delete item[this.setting.children]
          item[this.setting.leaf] = true
          continue
        } else {
          this.filterLevel(item[this.setting.children], maxLevel)
        }
      }
    },
    // 获取下拉框数据
    async getDictionary_option() {
      if (!this.dictType) {
        return
      }
      //获取该类型字典数据
      let dictData = []
      if (typeof this.dictType === "object") {
        this.type = this.dictType.type
        await store.actions.getDictDataObj(this.type)
        dictData = [].concat(this.dictCodes[this.type])
        const {
          filters,
          filterType = this.dictConfig.treeSetting.idField,
          reverse = false
        } = this.dictType
        const filtersArr =
          typeof filters === "string" ? filters.split(",") : filters
        if (reverse) {
          dictData = dictData.filter(item => {
            return !filtersArr.includes(item[filterType])
          })
        } else {
          dictData = dictData.filter(item => {
            return filtersArr.includes(item[filterType])
          })
        }
      } else {
        this.type = this.dictType
        await store.actions.getDictDataObj(this.type)
        dictData = [].concat(this.dictCodes[this.type])
      }

      //使用函数过滤数据
      if (this.filterDataFun) {
        dictData = this.filterDataFun(dictData)
      }

      //使用函数禁用数据
      if (this.disabledDataFun) {
        dictData = this.disabledDataFun(dictData)
      }

      if (this.disableObj) {
        const {
          disableValue,
          disableType = this.dictConfig.treeSetting.idField,
          reverse = false
        } = this.disableObj
        const disableList =
          typeof disableValue === "string"
            ? disableValue.split(",")
            : disableValue
        if (reverse) {
          dictData = dictData.map(item => {
            const targetItem = JSON.parse(JSON.stringify(item))
            targetItem.disabled =
              !disableList.includes(targetItem[disableType]) ||
              targetItem.disabled
            return targetItem
          })
        } else {
          dictData = dictData.map(item => {
            const targetItem = JSON.parse(JSON.stringify(item))
            targetItem.disabled =
              disableList.includes(targetItem[disableType]) ||
              targetItem.disabled
            return targetItem
          })
        }
      }

      this.list = dictData
    },
    // 下拉框点击事件
    handdleChange(val) {
      /* 子组件通过事件发射向父组件传递事件及参数，emit即为发射事件
        第一个参数为向父组件传递的事件名，第二个参数为向父组件传递的参数 */
      this.$emit("dictChange", val)
    },
    getRef() {
      return this.$refs.ElCascaderDict
    }
  }
}
</script>